/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getuserWalletList: (params) => {
    return axios.get(API_ENDPOINTS.GET_ALL_USERWALLET, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },
  getusersWalletLogs: (params) => {
    return axios.get(API_ENDPOINTS.GET_ALL_USERWALLET_LOGS, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },
  addwalletmoney: (data) => {
    return axios.post(API_ENDPOINTS.ADD_WALLET_AMOUNT, data, {
      headers: { isAuthRequired: true, "Content-Type": "application/json", },
    });
  },
  getdriverWalletList: (params) => {
    return axios.get(API_ENDPOINTS.GET_ALL_DRIVERWALLET, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },
  getdriversWalletLogs: (params) => {
    return axios.get(API_ENDPOINTS.GET_ALL_DRIVERWALLET_LOGS, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },
  // addwalletmoney: (id, data) => {
  //   let url = API_ENDPOINTS.ADD_WALLET_AMOUNT + "/" + id;
  //   return axios.put(url, data, {
  //     headers: { isAuthRequired: true, "Content-Type": "multipart/form-data", },
  //   });
  // },
  getManagerDetails: (id) => {
    return axios.get(API_ENDPOINTS.GET_MANAGER_DETAILS_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  addManager: (data) => {
    return axios.post(API_ENDPOINTS.ADD_MANAGER, data, {
      headers: { isAuthRequired: true, "Content-Type": "multipart/form-data", },
    });
  },
  deleteManager: (id) => {
    return axios.delete(API_ENDPOINTS.DELETE_MANAGER_DETAILS_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  }
};
